import { apiPost } from "@/lib/http/client";
import type { InvoiceSearchRequest, PayLinkSearchResponse } from "@/types/api";

export async function searchPayLinks(body: InvoiceSearchRequest) {
  return apiPost<PayLinkSearchResponse>("/pay-links/search", body);
}
